(function () {
  'use strict';

  const library = window.PellairNoteLibrary;
  if (!library || typeof library.resolve !== 'function') return;

  const observers = new WeakMap();
  const scheduled = new WeakMap();

  function clean(value) {
    return String(value || '').replace(/\s+/g, ' ').trim();
  }

  function splitNotes(value) {
    return clean(value)
      .split(/\s*(?:,|;|\u2022|\u00b7|\|)\s*/)
      .map(clean)
      .filter(Boolean);
  }

  function finderHref(noteName) {
    const config = window.PellairTheme && typeof window.PellairTheme === 'object' ? window.PellairTheme : {};
    const routes = config.routes || {};
    const root = String(routes.root || '/').replace(/\/?$/, '/');
    return root + '?finder_note=' + encodeURIComponent(noteName) + '#fragrance-library';
  }

  function markImageUnavailable(image) {
    if (!image || image.dataset.noteImageFailed === 'true') return;
    image.dataset.noteImageFailed = 'true';
    const media = image.closest('.fragrance-note-card__media, .taxonomy-note-card__media, .scent-guide__note-card-media');
    const card = image.closest('.fragrance-note-card, .taxonomy-note-card, .scent-guide__note-card');
    if (media) media.hidden = true;
    if (card) card.classList.add('is-image-missing');
  }

  function createImage(visual, label, width) {
    const image = document.createElement('img');
    image.src = library.url(visual, width || 240);
    image.srcset = [160, 240, 320].map(function (candidate) {
      return library.url(visual, candidate) + ' ' + candidate + 'w';
    }).join(', ');
    image.sizes = '(max-width: 359px) 22vw, (max-width: 749px) 18vw, 96px';
    image.alt = '';
    image.width = 640;
    image.height = 360;
    image.loading = 'lazy';
    image.decoding = 'async';
    image.setAttribute('data-note-image', '');
    image.addEventListener('error', function () { markImageUnavailable(image); }, { once: true });
    return image;
  }

  function createCard(item) {
    const link = document.createElement('a');
    link.className = 'fragrance-note-card';
    link.href = finderHref(item.name);
    link.setAttribute('aria-label', 'Explore oils with ' + item.name);

    const label = document.createElement('span');
    label.className = 'fragrance-note-card__label';
    label.textContent = item.name;
    label.title = item.name;

    if (item.visual && !item.visual.inferred) {
      const media = document.createElement('span');
      media.className = 'fragrance-note-card__media';
      media.appendChild(createImage(item.visual, item.name, 240));
      link.append(media, label);
    } else {
      link.classList.add('is-image-missing');
      link.appendChild(label);
    }
    return link;
  }

  function renderRow(row) {
    const text = row.querySelector('[data-note-level-text]') || row.querySelector('p');
    let target = row.querySelector('[data-note-level-visuals]');
    if (!text) return;
    if (!target) {
      const body = document.createElement('div');
      body.className = 'fragrance-pyramid__body';
      target = document.createElement('div');
      target.className = 'fragrance-pyramid__visuals';
      target.setAttribute('data-note-level-visuals', '');
      text.setAttribute('data-note-level-text', '');
      text.replaceWith(body);
      body.append(text, target);
    }

    const items = [];
    const used = new Set();
    splitNotes(text.textContent).forEach(function (name) {
      const visual = library.resolve(name);
      const nameKey = library.normalize(name);
      if (!nameKey || used.has(nameKey)) return;
      used.add(nameKey);
      items.push({ name: name, visual: visual && !visual.inferred ? visual : null });
    });

    row.classList.toggle('has-note-visuals', items.length > 0);
    if (items.length) text.setAttribute('aria-hidden', 'true');
    else text.removeAttribute('aria-hidden');
    const signature = items.map(function (item) {
      return (item.visual ? item.visual.filename : 'text-only') + ':' + item.name;
    }).join('|');
    if (target.dataset.noteVisualSignature === signature) return;
    target.dataset.noteVisualSignature = signature;
    target.replaceChildren();
    items.forEach(function (item) { target.appendChild(createCard(item)); });
    target.hidden = !items.length;
  }

  function renderPanel(panel) {
    panel.querySelectorAll('[data-fragrance-pyramid] .fragrance-pyramid__row').forEach(renderRow);
    panel.dataset.noteVisualsReady = panel.querySelector('[data-note-level-visuals]:not([hidden])')
      ? 'true'
      : 'unavailable';
  }

  function schedule(panel) {
    if (scheduled.has(panel)) return;
    const id = window.requestAnimationFrame(function () {
      scheduled.delete(panel);
      renderPanel(panel);
    });
    scheduled.set(panel, id);
  }

  function initPanel(panel) {
    if (!panel || observers.has(panel)) {
      if (panel) schedule(panel);
      return;
    }
    schedule(panel);
    const observer = new MutationObserver(function (mutations) {
      const meaningful = mutations.some(function (mutation) {
        const target = mutation.target.nodeType === 1 ? mutation.target : mutation.target.parentElement;
        return !target || !target.closest('[data-note-level-visuals]');
      });
      if (meaningful) schedule(panel);
    });
    observer.observe(panel, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['hidden'] });
    observers.set(panel, observer);
  }

  function hydrateGuideCard(card) {
    if (!card || card.dataset.noteGuideReady) return;
    const noteName = clean(card.getAttribute('data-note-name') || card.textContent);
    const visual = library.resolve(noteName);
    card.dataset.noteGuideReady = visual && !visual.inferred ? 'true' : 'unavailable';
    if (!visual || visual.inferred) return;
    const media = card.querySelector('[data-note-guide-media]');
    if (!media) return;
    media.appendChild(createImage(visual, noteName, 320));
    card.classList.add('has-note-image');
  }

  function init(root) {
    const scope = root && root.querySelectorAll ? root : document;
    if (scope.matches && scope.matches('[data-fragrance-detail]')) initPanel(scope);
    scope.querySelectorAll('[data-fragrance-detail]').forEach(initPanel);
    if (scope.matches && scope.matches('[data-note-guide-card]')) hydrateGuideCard(scope);
    scope.querySelectorAll('[data-note-guide-card]').forEach(hydrateGuideCard);
  }

  document.addEventListener('error', function (event) {
    const image = event.target;
    if (image && image.matches && image.matches('img[data-note-image]')) markImageUnavailable(image);
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('[data-fragrance-detail]').forEach(function (panel) {
      const observer = observers.get(panel);
      if (observer) observer.disconnect();
      observers.delete(panel);
      const frame = scheduled.get(panel);
      if (frame) window.cancelAnimationFrame(frame);
      scheduled.delete(panel);
    });
  });

  window.PellairNoteVisuals = { version: 'v2-embedded-note-stages', init: init };
})();
